import { useState, useEffect } from 'react';
import Utils from '@/common/utils/utils';
import ViewImage from './ViewImage';
import { getListAttachImageByAiChatPost } from '@/service/chatAIService';

function RenderAttachImageOnChatPost({ messageData }) {
    const [attachImages, setAttachImages] = useState([]);

    useEffect(() => {
        if (messageData?.attachments && !Utils.isEmptyArray(messageData?.attachments)) {
            setAttachImages(messageData?.attachments)
            return;
        }
        getListAttachImageByAiChatPost(messageData)
            .then(listAttachImgs => {
                if (listAttachImgs && !Utils.isEmptyArray(listAttachImgs)) {
                    setAttachImages(listAttachImgs);
                }
            })
            .catch(error => {
                console.log('getListAttachImageByAiChatPost error ', error);
            });
    }, [messageData]);

    return (
        // style={{display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'flex-end'}}
        <div className='ai-render-attach-img-list'>
            {!Utils.isEmptyArray(attachImages) &&
                attachImages.map(attData =>
                    <ViewImage key={attData?.id} imageData={attData} />
                )
            }
        </div>
    );
}

export default RenderAttachImageOnChatPost;
